import BotConfigForm from '@/components/bot/BotConfigForm'
import BotSettingsNavTabs from '@/components/bot/BotSettingsNavTabs'
import { Bot } from 'lucide-react'

export default function BotSettings() {
  return (
    <div className="p-4 sm:p-6 overflow-x-hidden min-h-screen bg-slate-50">
      {/* Header */}
      <div className="mb-4 sm:mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#075E54]/10 rounded-xl flex items-center justify-center flex-shrink-0">
            <Bot className="w-5 h-5 text-[#075E54]" />
          </div>
          <div>
            <h1 data-tour="bot-settings-main" className="text-xl sm:text-2xl font-bold text-gray-900 leading-tight">Configuración del Agente IA</h1>
            <p className="text-xs sm:text-sm text-gray-600">
              Personalidad, prompt de ventas, modelo lingüístico y reglas comerciales del bot
            </p>
          </div>
        </div>
      </div>

      <BotSettingsNavTabs />

      <BotConfigForm />
    </div>
  )
}
